
export const getServerUrl = () => {
    // Detect if we are in the production or development environment
    if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
        // IF we are in production gets the production server URL
        return window.location.origin+":8000";
    } else {
        // IF we are in development gets the development or local server URL
        return 'http://localhost:8000'; 
    }
};
